import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";
import { Link } from "react-router-dom";

const GlobalInvestments = () => {
  useEffect(() => {
    if (window.jQuery && window.$.fn.tab) {
      window.$(".tab1").tab();
      window.$(".tab2").tab({ trigger_event_type: "mouseover" });
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="global-investments-page">
      <SEO
        title="Global Investments"
        description="Access international markets and diversify your portfolio globally with expert support. Participate in worldwide innovation cycles and multinationals."
      />

      <section className="service-banner">
        <img
          src="/images/banners/global-banner.avif"
          alt="Global Investments Banner"
          loading="eager"
          id="service-desktop-banner"
        />
        <img
          src="/images/banners/global-mobile-banner.avif"
          alt="Global Investments Mobile Banner"
          loading="eager"
          id="service-mobile-banner"
        />
        <div className="services-banner-content">
          <h1 data-aos="fade-up">
            Global <span>Investment</span>
          </h1>
          <div className="banner-highlights" data-aos="fade">
            <span>Invest</span>
            <span>Grow</span>
            <span>Secure</span>
          </div>
        </div>
      </section>

      <section className="offered-services">
        <div className="container">
          <div className="offered-services-left">
            <h2 data-aos="fade-up">
              <span>What</span> <br /> We Offer
            </h2>
            <p>
              In an increasingly interconnected world, portfolio diversification
              beyond domestic markets has become an essential component of
              long-term wealth creation. Our Global Investments platform enables
              eligible investors to access international opportunities across
              developed and emerging markets, subject to applicable regulatory
              guidelines.
            </p>
            <p>
              By incorporating global exposure, investors can participate in
              worldwide innovation cycles, sectoral leaders, and multinational
              enterprises that may not be available within domestic markets.
              International allocation can enhance diversification, reduce
              concentration risk, and create access to global economic growth
              trends.
            </p>
          </div>
          <div className="offered-services-right">
            <img
              src="/images/services/global-offer.avif"
              alt="Global Investments Platform Overview"
              loading="lazy"
            />
          </div>
        </div>

        <img
          src="/images/services/offer-bg.avif"
          alt=""
          className="offer-bg"
          aria-hidden="true"
        />
      </section>

      <section className="services-divider">
        <div className="services-divider-left"></div>
        <div className="services-divider-right"></div>
      </section>

      <section className="services-highlights">
        <div className="container">
          <div className="services-highlights-left">
            <h2 data-aos="fade-up">Key Highlights</h2>
            <p>
              Expand your portfolio beyond borders with access to international
              markets. Diversify risk and tap into global growth opportunities
              with ease.
            </p>
            <img
              src="/images/services/global-highlight.png"
              alt="Global Investments Key Highlights Graphic"
              loading="lazy"
            />
          </div>

          <div className="services-highlights-right">
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Exposure to global equities & ETFs</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Diversification across geographies</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Participation in global growth themes</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Currency risk awareness guidance</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Regulatory-compliant investment process</p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-disclaimer">
        <div className="container">
          <p>
            <b>Disclaimer</b>: Overseas investments are subject to RBI and FEMA
            guidelines and prescribed limits. Foreign investments involve
            currency, geopolitical, and market risks.
          </p>
        </div>
      </section>

      <section className="services-app-download">
        <div className="container">
          <div className="services-app-download-left">
            <img
              src="/images/download.avif"
              alt="Investment Mobile App Preview"
              loading="lazy"
            />
          </div>
          <div className="services-app-download-right">
            <h3 data-aos="fade-up">
              Download Our <br /> Investment Fund App
            </h3>
            <p>Investing With Gateway Financial Services Limited</p>
            <Link to="/" className="download-btn lm-btn">
              Download Now
            </Link>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default GlobalInvestments;
